/**
 * Utility for conditionally joining classNames
 * Simple implementation without external dependencies
 */

type ClassValue = string | number | boolean | undefined | null | ClassValue[];

export function cn(...classes: ClassValue[]): string {
  const result: string[] = [];

  for (const cls of classes) {
    if (typeof cls === 'string' && cls.length > 0) {
      result.push(cls);
    } else if (typeof cls === 'number') {
      result.push(String(cls));
    } else if (Array.isArray(cls)) {
      const nested = cn(...cls);
      if (nested) {
        result.push(nested);
      }
    }
  }

  return result.join(' ');
}
